<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <div
      [ngClass]="
        isPatientActive ? 'patient-name' : 'patient-name name-not-active'
      "
    >
      <h2>{{ patientNameAndSurname }}</h2>
    </div>
    <button type="button" class="navigate-ai-chip" (click)="navigateToAiPage()">
      <mat-icon>arrow_back</mat-icon>
      <span>Analisi AI</span>
    </button>
    <section class="ai-section">
      <header class="header">
        <div class="sections">
          <!-- Pat Dmr Section -->
          <div
            (click)="navigateTo('scheda-clinica-dinamica')"
            [class.selected]="patDmrSelected"
            [class.not-selected]="!patDmrSelected"
          >
            <h2 style="text-align: center">
              {{ labelService.getLabel("Scheda Clinica Dinamica") }}
            </h2>
          </div>

          <!-- PatSumm Section -->
          <div
            (click)="navigateTo('sintesi-complessiva')"
            [class.selected]="summaryAllSelected"
            [class.not-selected]="!summaryAllSelected"
          >
            <h2 style="text-align: center">
              {{ labelService.getLabel("Sintesi Complessiva") }}
            </h2>
          </div>

          <!-- Graphs Section -->
          <div
            (click)="navigateTo('grafico-topic')"
            [class.selected]="graphicsSelected"
            [class.not-selected]="!graphicsSelected"
          >
            <h2 style="text-align: center">
              {{ labelService.getLabel("Grafico Topic") }}
            </h2>
          </div>
        </div>
        <div class="info-button-container">
          @if (summaryAllSelected || patDmrSelected) {
            <app-button
              [icon]="isEditing ? 'save' : 'edit'"
              (click)="toggleEdit()"
            ></app-button>
          }
          <button
            mat-icon-button
            aria-label="Info"
            class="info-button"
            (click)="toggleInfoPanel()"
          >
            <mat-icon>info</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="downloadPDF()"
            aria-label="Download PDF"
            class="info-button"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </header>

      <div class="ai-disclaimer-slot">
        <app-ai-disclaimer></app-ai-disclaimer>
      </div>

      <div class="table-container">
        @if (patDmrSelected) {
          <app-ai-patdmr
            [patDmrRelatedData]="patDmr!"
            [isEditing]="isEditing"
            [patientId]="patientId"
            [isLoading]="isLoadingPatDmr"
          ></app-ai-patdmr>
        }
        @if (summaryAllSelected) {
          <app-ai-summary-all
            [summaryAll]="summaryAll"
            [isEditing]="isEditing"
            [patientId]="patientId"
            [isLoading]="isLoadingPatSumm"
          ></app-ai-summary-all>
        }
        @if (graphicsSelected) {
          <app-ai-graphics
            [catDistrPerEachAppointment]="catDistrPerEachAppointment"
          ></app-ai-graphics>
        }
      </div>
    </section>

    @if (showInfoPanel) {
      <app-info-panel
        [infoTitle]="infoTitle"
        [infoText]="infoText"
        (close)="toggleInfoPanel()"
      ></app-info-panel>
    }
  </main>
</app-side-top-bar>
